module.exports = __webpack_public_path__ + "static/media/realtalk_sd_ren261eb256f9e5a4e719a4b9c103e2b1b1.webp";